import React from "react";
import colors from "theme/config/colors";
import Button, { Theme } from "theme/components/buttons/Button";

const TransparentButton = (props: any) => {
    const theme: Theme = {
        color: colors.black,
        backgroundColor: "transparent",
        disabled: {
            opacity: "30%",
        },
    };

    return <Button {...props} theme={theme} />;
};

export default TransparentButton;
